(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends customElements.get(
    'slider-component'
  ) {
    constructor() {
      super();
      this.options = {
        ...this.options,
        ...{
          spaceBetween: 18,
          loop: true,
          slidesPerView: 2,
          // width: this.hasAttribute('data-fixed-width')
          //   ? this.dataset.fixedWidth
          //   : 310,
          breakpoints: {
            450: {
              slidesPerView: 2,
            },
            750: {
              slidesPerView: 3,
            },
            990: {
              speed: 1000,
              slidesPerView: 4,
              spaceBetween: this.hasAttribute('data-space-between') ? Number(this.dataset.spaceBetween) : 56,
              width: null,
              // width: this.hasAttribute('data-fixed-width-desktop')
              //   ? this.dataset.fixedWidthDesktop
              //   : 432
            },
            1390: {
              slidesPerView: 5,
            },
          },
          on: {
            init: swiper => {
              swiper.imagesToLoad.forEach(image => {
                if (!image.classList.contains('lazyloading')) {
                  return;
                }

                if (image.src) {
                  image.classList.remove('lazyloading');
                  image.classList.add('lazyloaded');
                }
              })
            }
          }
        },
      };

      if (this.hasAttribute('data-slides-per-view')) {
        this.options.breakpoints[750].width = this.options.width;
        this.options.breakpoints[750].slidesPerView =
          this.getAttribute('data-slides-per-view');
        this.options.breakpoints[990].width = null;
        this.options.breakpoints[990].slidesPerView =
          this.getAttribute('data-slides-per-view');
        this.options.width = null;
        this.slidesPerView = this.getAttribute(
          'data-slides-per-view'
        );
      }

      if (this.hasAttribute('data-slides-per-view-desktop')) {
        this.options.breakpoints[990].width = null;
        this.options.breakpoints[990].slidesPerView =
          this.getAttribute('data-slides-per-view-desktop');
        this.options.breakpoints[1390].width = null;
        this.options.breakpoints[1390].slidesPerView =
          this.getAttribute('data-slides-per-view-desktop');

      }

      if (this.dataset.autoplay === 'true') {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed
        };
      }
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
